import { ISearchQueryParams } from "../../../../../redux/store.types"

export interface IBuildLeadsQueryParams {
    contact_number_one: string,
    name_of_guest: string,
    preferred_venue: string,
    preferred_venue_uuid: string,
    function_date: string,
    event_time: string,
    event_time_uuid: string,
    event_type: string,
}

export const buildLeadsQueryParams = (params: IBuildLeadsQueryParams): string => {
    let advanseFilter: ISearchQueryParams["advanceFilter"] = []
    if (params.contact_number_one && params.contact_number_one.trim().length > 0) {
        advanseFilter.push({
            column: ["contact_number_one"],
            operator: "CONTAINS",
            value: params.contact_number_one,
            logicalOperator: "AND"
        })
    }
    if (params.name_of_guest && params.name_of_guest.trim().length > 0) {
        advanseFilter.push({
            column: ["name_of_guest"],
            operator: "CONTAINS",
            value: params.name_of_guest,
            logicalOperator: "AND"
        })
    }
    if (params.preferred_venue && params.preferred_venue.trim().length > 0) {
        advanseFilter.push({
            column: ["preferred_venue"],
            operator: "CONTAINS",
            value: params.preferred_venue,
            logicalOperator: "AND"
        })
    }
    if (params.function_date && params.function_date.trim().length > 0) {
        advanseFilter.push({
            column: ["function_date"],
            operator: "CONTAINS",
            value: params.function_date,
            logicalOperator: "AND"
        })
    }
    if (params.event_time && params.event_time.trim().length > 0) {
        advanseFilter.push({
            column: ["event_time"],
            operator: "CONTAINS",
            value: params.event_time,
            logicalOperator: "AND"
        })
    }

    if (params.event_type && params.event_type.trim().length > 0) {
        advanseFilter.push({
            column: ["event_type"],
            operator: "CONTAINS",
            value: params.event_type,
            logicalOperator: "AND"
        })
    }
    return advanseFilter.length > 0 ? `${JSON.stringify(advanseFilter)}` : ''
}